(function() {
  const STORAGE_KEY = 'liked_products';

  function getLikedProducts() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setLikedProducts(ids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }

  function syncLikeButtons(container = document) {
    const likedIds = getLikedProducts().map(String);
    container.querySelectorAll('.product-card__like-btn').forEach(btn => {
      const id = String(btn.dataset.productId);
      if (likedIds.includes(id)) {
        btn.classList.add('is-liked');
      } else {
        btn.classList.remove('is-liked');
      }
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card__like-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = String(btn.dataset.productId);
    let likedIds = getLikedProducts().map(String);

    if (likedIds.includes(productId)) {
      likedIds = likedIds.filter(id => id !== productId);
    } else {
      likedIds.push(productId);
    }

    setLikedProducts(likedIds);
    syncLikeButtons(); 
  });

  document.addEventListener('DOMContentLoaded', () => syncLikeButtons());
  document.addEventListener('shopify:section:load', () => syncLikeButtons());

  const observer = new MutationObserver((mutations) => {
    let hasAddedNodes = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        hasAddedNodes = true;
        break;
      }
    }
    if (hasAddedNodes) syncLikeButtons();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  window.syncLikeButtons = syncLikeButtons;
})();